globalThis.BlockSelector = class BlockSelector extends Card {
  constructor() {
    super({ closable: false });
    this.abort = new AbortController();
    this.div.id = "block-selector";
    this.title.innerText = "Blocks";
    this.index = 0;
    this.blocks = [];
    for (let i = 0; i < globalThis.BLOCKS; i++) {
      const block = Block.of(i);
      block.div.addEventListener(
        "click",
        () => {
          this.index = i;
          this.renderActive();
        },
        this.abort,
      );
      this.content.append(block.div);
      this.blocks.push(block);
    }
    this.renderActive();
    this.centerY();
  }

  remove() {
    super.remove();
  }

  renderActive() {
    for (let i = 0; i < globalThis.BLOCKS; i++) {
      const block = this.blocks[i];
      if (i === this.index) block.div.classList.add("active");
      else block.div.classList.remove("active");
    }
  }
};
